'use strict';

/*
 * factored out of log.js to separate JET dependencies
 *
 * Created a custom writer, and installs it to JET; no need to actually use the OjCustomWriter class returned
 */
define('vb/private/logCustomWriter',['ojs/ojlogger', 'vb/private/constants', 'vb/private/log'], (ojLogger, Constants, Log) => {
  const MATCH_MARKER_REGEX = /%s|%o|%O|%d|%i|%f/g;
  const SPLIT_MARKER_REGEX = /\s?(%s|%o|%O|%d|%i|%f)\s?/;
  /**
   * Custom writer for oj.Logger that delegates to the vb logger.
   */
  class OjCustomWriter {
    constructor() {
      this.logger = Log.getLogger('/oj');
    }

    info(...args) {
      this.logger.info(...this.format(args));
    }

    warn(...args) {
      this.logger.warn(...this.format(args));
    }

    error(...args) {
      this.logger.error(...this.format(args));
    }

    log(...args) {
      this.logger.finer(...this.format(args));
    }

    /**
     * JET messages use % markers for substitution. This method formats a JET message by replacing all % markers with
     * arguments in args.
     *
     * @param args
     */
    format(args) {
      const [firstArg, ...restArgs] = args;
      if (typeof firstArg === 'string' && firstArg.match(MATCH_MARKER_REGEX)) {
        let usedArgsCount = 0;
        const formattedParts = [];
        // Split the first argument using MARKER_REGEX while keeping placeholders using match()
        firstArg.split(SPLIT_MARKER_REGEX).forEach((segment, index) => {
          if (index % 2 === 0) {
            // Only add actual non-empty text parts (ignoring matched specifiers)
            if (segment) {
              formattedParts.push(segment);
            }
          } else if (usedArgsCount < restArgs.length) {
            // Replace matched format specifier at odd indices with its corresponding argument
            formattedParts.push(restArgs[usedArgsCount]);
            usedArgsCount += 1;
          } else {
            // No matching argument left, retain the format specifier
            formattedParts.push(segment);
          }
        });
        // Append any remaining arguments
        return [...formattedParts, ...restArgs.slice(usedArgsCount)];
      }
      return args;
    }
  }

  // install the custom log writer
  ojLogger.option('writer', new OjCustomWriter());

  return OjCustomWriter;
});

